import BaseReportResults from '../common/base-report-results'
import InitiativeReportTableModel from './initiative-report-table-model'

const InitiativeReportResults = BaseReportResults.extend({

	_reportTableModel() {
		return InitiativeReportTableModel
	}

})

export default InitiativeReportResults
InitiativeReportResults.__filename__ = 'reports/initiative-report/initiative-report-results.js'
